import { gql } from '@apollo/client';

export const DeleteServiceSubscriptionIpRestriction = gql`
  mutation DeleteServiceSubscriptionIpRestriction($immutableId: String!) {
    deleteIPRange(immutableId: $immutableId) {
      immutableId
    }
  }
`;
